import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";

interface NavItem {
  path: string;
  label: string;
  icon: string;
}

const navItems: NavItem[] = [
  { path: "/dashboard", label: "Dashboard", icon: "ri-dashboard-line" },
  { path: "/veliler", label: "Veliler / Öğrenciler", icon: "ri-team-line" },
  { path: "/kampanyalar", label: "WhatsApp Kampanyaları", icon: "ri-whatsapp-line" },
  { path: "/hatirlatmalar", label: "Otomatik Hatırlatmalar", icon: "ri-notification-3-line" },
  { path: "/referans", label: "Referans Takibi", icon: "ri-user-add-line" },
  { path: "/odeme", label: "Ödeme Takibi", icon: "ri-money-cny-circle-line" },
  { path: "/taahhut", label: "Taahhüt Takibi", icon: "ri-file-list-3-line" },
  { path: "/sablonlar", label: "Mesaj Şablonları", icon: "ri-file-text-line" },
  { path: "/gonderim", label: "Gönderim Takibi", icon: "ri-send-plane-line" },
  { path: "/raporlar", label: "Raporlar", icon: "ri-bar-chart-2-line" },
  { path: "/ayarlar", label: "Ayarlar", icon: "ri-settings-3-line" },
];

interface SidebarProps {
  mobileOpen: boolean;
  onClose: () => void;
}

export default function Sidebar({ mobileOpen, onClose }: SidebarProps) {
  const navigate = useNavigate();

  const handleLogout = () => {
    navigate("/");
  };

  return (
    <>
      {/* Mobile overlay */}
      {mobileOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 lg:hidden"
          onClick={onClose}
        />
      )}

      {/* Sidebar */}
      <aside
        className={`
          fixed top-0 left-0 h-full w-64 bg-[#0B1120] z-50 flex flex-col
          transition-transform duration-300 ease-in-out
          ${mobileOpen ? "translate-x-0" : "-translate-x-full"}
          lg:translate-x-0 lg:static lg:z-auto
        `}
      >
        {/* Logo */}
        <div className="flex items-center gap-3 px-6 py-5 border-b border-white/10">
          <div className="w-9 h-9 flex items-center justify-center bg-[#25D366] rounded-xl">
            <i className="ri-whatsapp-line text-white text-lg"></i>
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-white font-bold text-sm leading-tight">Veli İletişim</p>
            <p className="text-white/40 text-xs leading-tight">Hatırlatma Paneli</p>
          </div>
          <button
            onClick={onClose}
            className="lg:hidden w-7 h-7 flex items-center justify-center text-white/50 hover:text-white cursor-pointer"
          >
            <i className="ri-close-line text-lg"></i>
          </button>
        </div>

        {/* Nav */}
        <nav className="flex-1 overflow-y-auto py-4 px-3">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              onClick={onClose}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-xl mb-0.5 text-sm font-medium transition-all duration-150 cursor-pointer whitespace-nowrap
                ${isActive
                  ? "bg-white/10 text-white border-l-[3px] border-[#25D366] pl-[calc(0.75rem-3px)]"
                  : "text-white/60 hover:bg-white/5 hover:text-white"
                }`
              }
            >
              <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                <i className={`${item.icon} text-base`}></i>
              </div>
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>

        {/* Bottom */}
        <div className="px-3 pb-5 border-t border-white/10 pt-4">
          <div className="flex items-center gap-3 px-3 py-2.5 mb-1">
            <div className="w-8 h-8 rounded-full bg-[#25D366] flex items-center justify-center flex-shrink-0">
              <span className="text-white text-xs font-bold">EK</span>
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-white text-sm font-medium leading-tight truncate">Eğitim Danışmanı</p>
              <p className="text-white/40 text-xs leading-tight truncate">GoStudent</p>
            </div>
          </div>
          <button
            onClick={handleLogout}
            className="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm text-white/60 hover:bg-white/5 hover:text-white transition-all duration-150 cursor-pointer"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-logout-box-r-line text-base"></i>
            </div>
            <span>Çıkış Yap</span>
          </button>
        </div>
      </aside>
    </>
  );
}